
const state = {
	id_participant: '-1',
	firstname_participant: '',
	lastname_participant: '',
	telephone_participant: '',
	insight_finish: 0,
	email_participant: '',
	participant_color1: 0,
	participant_color2: 0,
	participant_color3: 0,
	participant_color4: 0,
	insight_updated_at: '',
	participant_url_resultats: '',
}
const mutations = {
	NEW_PARTICIPANT(state, payload) {
		state.id_participant = payload.id
		state.firstname_participant = payload.firstname
		state.lastname_participant = payload.lastname
		state.email_participant = payload.email
		state.telephone_participant = payload.telephone
		state.insight_finish = 0
		state.participant_url_resultats = payload.url_resultats
	},
	UPDATE_PARTICIPANT(state, payload) {
		state.id_participant = payload[0].id
		state.firstname_participant = payload[0].firstname
		state.lastname_participant = payload[0].lastname
		state.email_participant = payload[0].email
		state.telephone_participant = payload[0].telephone
		state.insight_finish = 0
		state.participant_color1 = payload[0].color1
		state.participant_color2 = payload[0].color2
		state.participant_color3 = payload[0].color3
		state.participant_color4 = payload[0].color4
		state.participant_url_resultats = payload[0].url_resultats
		state.insight_updated_at = payload[0].updated_at
	},
	UPDATE_INSIGHT_FINISH(state, payload) {
		state.insight_finish = payload
	}
}

const actions = {
}
const getters = {
	id_participant: state => state.id_participant,
	insight_finish: state => state.insight_finish,
	email_participant: state => state.email_participant,
	firstname: state => state.firstname_participant,
	lastname: state => state.lastname_participant,
	telephone: state => state.telephone_participant,
	color1: state => state.participant_color1,
	color2: state => state.participant_color2,
	color3: state => state.participant_color3,
	color4: state => state.participant_color4,
	date: state => state.insight_updated_at,
	url_resultats: state => state.participant_url_resultats,
}

const participantModule = {
	state,
	mutations,
	actions,
	getters
}

export default participantModule;